export const Breakpoints = {
  mobile: 320,
  tabletLow: 576,
  tabletMidle: 768,
  tabletBig: 992,
  pcLow: 1200,
  pcBig: 1440
};
